import { useEffect } from "react"

export const useFreeze = () => {
  // Disable body scrolling when mobile menu open
  useEffect(() => {
    if (typeof document === "undefined") return // SSR guard

    const body = document.body
    const header = document.querySelector<HTMLElement>("header")

    body.style.overflowY = "hidden"
    if (header) {
      header.style.zIndex = "-1"
    }
    return () => {
      document.body.style.overflowY = "unset"
      if (header) {
        header.style.zIndex = "99"
      }
    }
  }, [])
}
